<div *ngIf="message"
                  class="alert-dismissible"
                  [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-info': message.type === 'info', 'alert-warning': message.type === 'warning', 'alert-danger': message.type === 'error' }"
                  [innerHTML]="message.text"></div>